<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="110px">
      <div v-if="!form.card_id" class="content-center content-bottom-padded">
        <el-radio-group v-model="form.card_type" @change="handleTypeChange">
          <el-radio-button label="discount">折扣券</el-radio-button>
          <el-radio-button label="cash">代金券</el-radio-button>
          <el-radio-button label="gift">兑换券</el-radio-button>
          <el-radio-button label="service">服务券</el-radio-button>
          <el-radio-button label="free_shipping">免邮券</el-radio-button>
        </el-radio-group>
      </div>
      <el-card shadow="never" header="基础信息">
        <label style="margin-left: 37px;color: red;">备注：修改过后用户已经领取过的优惠券将清空，包含已经使用过的优惠券</label>
        <!-- <el-form-item label="营销类型" prop="promotion_type">
          <el-radio-group v-model="form.promotion_type">
            <el-radio   :label="0">无</el-radio>
            <el-radio   :label="1">仅限正价商品使用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="优惠基准" prop="discount_again">
          <el-radio-group v-model="form.discount_again">
            <el-radio   label="1">零售价</el-radio>
            <el-radio   label="2">折扣价</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="兑换商品名称" prop="gift" v-if="form.card_type === 'gift'">
           <el-input :maxlength="20" placeholder="兑换商品名称" v-model="form.gift" style="width: 240px;" @change="giftChange"></el-input>&nbsp;<span class="frm-tips">{{inputValue.gift_length}}/{{inputValue.gift_max}}</span>
        </el-form-item>
        <el-form-item label="折扣额度" prop="discount" v-if="form.card_type === 'discount'">
           <!-- <el-input :disabled="form.card_id ? true : false" v-model="form.discount" placeholder="只能是大于等于1,小于10的数字" style="width: 240px;" max="9.9" min="1"></el-input> -->
           <el-input v-model="form.discount" placeholder="只能是大于等于1,小于10的数字" style="width: 240px;" max="9.9" min="1"></el-input>
        </el-form-item>
        <el-form-item label="减免金额" prop="reduce_cost" v-if="form.card_type === 'cash'">
           <!-- <el-input :disabled="form.card_id ? true : false" v-model="form.reduce_cost" placeholder="只能是大于0的数字" style="width: 240px;"></el-input>&nbsp;元 -->
           <el-input v-model="form.reduce_cost" placeholder="只能是大于0的数字" style="width: 240px;"></el-input>&nbsp;元
        </el-form-item>
        <el-form-item label="发放数量" prop="quantity">
          <!-- <el-input :disabled="form.card_id ? true : false" type="text" oninput = "value=value.replace(/[^\d.]/g,'')" v-model.number="form.quantity" placeholder="只能是大于0的数字" style="width: 20%;"></el-input>&nbsp;份 -->
          <el-input type="text" oninput = "value=value.replace(/[^\d.]/g,'')" v-model.number="form.quantity" placeholder="只能是大于0的数字" style="width: 20%;"></el-input>&nbsp;份
        </el-form-item>
        <el-form-item label="卡券标题" prop="title">
           <!-- <el-input :disabled="form.card_id ? true : false" v-model="form.title" placeholder="字数上限为13个汉字" style="width: 240px;" @change="titleChange"></el-input>&nbsp; -->
           <el-input v-model="form.title" placeholder="字数上限为30个汉字" style="width: 240px;" @change="titleChange"></el-input>&nbsp;
           <span class="frm-tips">{{inputValue.title_length}}/{{inputValue.title_max}}</span>
           <p class="frm-tips">建议填写代金券“减免金额”及自定义内容，描述卡券提供的具体优惠</p>
        </el-form-item>
         <el-form-item label="精简标题" prop="str_title">
           <!-- <el-input :disabled="form.card_id ? true : false" v-model="form.title" placeholder="字数上限为13个汉字" style="width: 240px;" @change="titleChange"></el-input>&nbsp; -->
           <el-input v-model="form.str_title" placeholder="字数上限为30个汉字" style="width: 240px;" @change="strTitleChange"></el-input>&nbsp;
           <span class="frm-tips">{{inputValue.str_title_length}}/{{inputValue.str_title_max}}</span>
           <p class="frm-tips">建议根据标题精简优惠券提示</p>
        </el-form-item>
        <el-form-item label="分类">
            <el-select size="small" v-model="form.cate_id"   clearable placeholder="请选择分类" @change="handleCateChange">
                <el-option v-for="item in category" :key="form.cate_id ? form.cate_id :item.cate_id" :label="item.name" size="mini"   :value="item.cate_id"> </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="长合约">
          <el-select size="small" v-model="form.is_long"   clearable placeholder="是否长合约" @change="handlelongCateChange">
            <el-option label="否" size="mini"  :value="0"></el-option>
            <el-option label="是" size="mini"  :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用条件" prop="useCondition">
          <!-- <el-radio-group :disabled="form.card_id ? true : false" v-model="form.useCondition" @change="conditionChange">
            <template v-if="form.card_type != 'cash'"><el-radio :label="1">不限制</el-radio></template>
            <template v-if="form.card_type !== 'gift'">
              <el-radio :label="2">满 &nbsp;<el-input :disabled="form.card_id || form.useCondition == 1 ? true : false" v-model="form.least_cost" style="width: 100px;"></el-input>&nbsp; 元可用&nbsp;&nbsp;
                <template v-if="form.card_type === 'discount'"> 最高限额&nbsp;<el-input :disabled="form.card_id || form.useCondition == 1 ? true : false" v-model="form.most_cost" style="width: 100px;"></el-input>&nbsp; 元</template>
              </el-radio>

            </template>
          </el-radio-group> -->
          <el-radio-group v-model="form.useCondition" @change="conditionChange">
            <template><el-radio :label="1">不限制</el-radio></template>
            <template>
              <el-radio :label="2">满 &nbsp;<el-input v-model="form.least_cost" style="width: 100px;"></el-input>&nbsp; 元可用&nbsp;&nbsp;
                <template> 最高限额&nbsp;<el-input v-model="form.most_cost" style="width: 100px;"></el-input>&nbsp; 元</template>
                <template> 每个商品最低购买&nbsp;<el-input v-model="form.min_buy_num" style="width: 100px;"></el-input>&nbsp; 个可用</template>
              </el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期" prop="date_type">
          <!-- <el-radio-group v-model="form.date_type" @change="changeDatetime">
            <div v-if="!form.card_id || form.card_id && form.date_type === 'DATE_TYPE_FIX_TIME_RANGE'" style="margin-bottom: 20px;">
              <el-radio :disabled="form.card_id != '' && form.date_type == 'DATE_TYPE_FIX_TERM' ? true : false" label="DATE_TYPE_FIX_TIME_RANGE">固定日期</el-radio>
              <el-date-picker v-model="date_range" type="datetimerange" value-format="timestamp" :picker-options="form.card_id ? '' : pickerOptions" style="width:380px" :disabled="form.date_type == 'DATE_TYPE_FIX_TERM' ? true : false"></el-date-picker>
            </div>
            <div v-if="!form.card_id || form.card_id && form.date_type === 'DATE_TYPE_FIX_TERM'">
              <el-radio label="DATE_TYPE_FIX_TERM" :disabled="form.card_id != '' && form.date_type == 'DATE_TYPE_FIX_TIME_RANGE' ? true : false">领取后,&nbsp;
              <el-select v-model="form.begin_time" :disabled="form.card_id != '' && form.date_type == 'DATE_TYPE_FIX_TERM' ? true : datetimeStatus ? true : false" size="5">
                <el-option v-for="item in totalDays" :key="item.value" :label="item.text" :value="item.value"></el-option>
              </el-select>&nbsp;生效，有效天数&nbsp;
              <el-select v-model="form.days" :disabled="form.card_id != '' && form.date_type == 'DATE_TYPE_FIX_TERM' ? true : datetimeStatus ? true : false" size="5">
                <el-option v-for="item in remainDays" :key="item.value" :label="item.text" :value="item.value"></el-option>
              </el-select>
              统一过期时间&nbsp;<el-date-picker v-model="form.end_time" type="datetime" value-format="timestamp" :picker-options="pickerOptions" :disabled="form.card_id != '' && form.date_type == 'DATE_TYPE_FIX_TERM' ? true : datetimeStatus ? true : false"></el-date-picker>
              </el-radio>
            </div>
          </el-radio-group> -->
          <el-radio-group v-model="form.date_type" @change="changeDatetime">
            <div v-if="!form.card_id || form.card_id && form.date_type === 'DATE_TYPE_FIX_TIME_RANGE'" style="margin-bottom: 20px;">
              <el-radio  label="DATE_TYPE_FIX_TIME_RANGE">固定日期</el-radio>
              <el-date-picker
                      v-model="date_range"
                      type="datetimerange"
                      value-format="timestamp"
                      :default-time="['00:00:00', '23:59:59']"
                      :picker-options="form.card_id ? '' : pickerOptions"
                      style="width:380px"  >
              </el-date-picker>

            </div>
            <div v-if="!form.card_id || form.card_id && form.date_type === 'DATE_TYPE_FIX_TERM'">
              <el-radio label="DATE_TYPE_FIX_TERM" >领取后,&nbsp;
              <el-select v-model="form.begin_time"  size="5">
                <el-option v-for="item in totalDays" :key="item.value" :label="item.text" :value="item.value"></el-option>
              </el-select>&nbsp;生效，有效天数&nbsp;
              <el-select v-model="form.days" size="5">
                <el-option v-for="item in remainDays" :key="item.value" :label="item.text" :value="item.value"></el-option>
              </el-select>
              统一过期时间&nbsp;<el-date-picker
                        v-model="form.end_time"
                        type="datetime"
                        value-format="timestamp"
                        default-time="23:59:59"
                        :picker-options="pickerOptions"></el-date-picker>
              </el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="卡券使用说明" prop="description">
          <el-input type="textarea" :rows="6" resize="none" v-model="form.description" style="width: 600px" placeholder="请填写使用本优惠券的注意事项" @change="descriptionChange"></el-input>&nbsp;<span class="frm-tips">{{inputValue.description_length}}/{{inputValue.description_max}}</span>
        </el-form-item>
      </el-card>
      <el-card shadow="never" header="适用规则">
        <el-form-item label="前台直接领取">
          <el-switch v-model="form.receive" active-color="#13ce66" inactive-color="#d2d4db"></el-switch>
        </el-form-item>
        <el-form-item label="扫码领取">
          <el-switch v-model="form.can_qrcode_flag" active-color="#13ce66" inactive-color="#d2d4db"></el-switch>
          <p class="frm-tips">勾选扫码领取前，关闭前台可领。只能通过扫码领不再优惠券列表展示</p>
        </el-form-item>
        <el-form-item label="领券限制">
           <el-input v-model="form.get_limit" style="width: 120px;"></el-input>
           <p class="frm-tips">每个用户领券上限，如不填，则默认为1</p>
        </el-form-item>
        <el-form-item label="适用平台" v-if="is_distributor == false || form.card_type != 'gift'">
          <el-radio-group v-model="form.use_platform" :disabled="form.card_id != ''" @change="usePlatformChange">
            <el-radio label="store" v-if="is_distributor == false">门店专用</el-radio>
            <el-radio label="mall" v-if="form.card_type != 'gift'">线上商城专用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="核销场景" prop="use_scenes" v-if="is_distributor == false">
          <el-radio-group v-model="form.use_scenes" :disabled="form.card_id != ''">
            <el-radio v-if="form.card_type != 'gift' && form.use_platform == 'mall' " label="ONLINE">线上商城使用</el-radio>
            <el-radio v-if="form.card_type != 'gift' && form.use_platform == 'store'" label="QUICK">快捷买单使用</el-radio>
            <el-radio label="SELF" v-if="form.use_platform == 'store'">自助核销（到店使用）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="使用限制" prop="merchant_isuse">
          <el-radio-group v-model="form.merchant_isuse" >
            <el-radio   :label="0" >怡康自营</el-radio>
            <el-radio   :label="1">第三方商家</el-radio>
            <el-radio   :label="2">全平台可使用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="费用承担" prop="merchant_iscost">
          <el-radio-group v-model="form.merchant_iscost" >
            <el-radio   :label="0">怡康自营</el-radio>
            <el-radio   :label="1">第三方商家</el-radio>
          </el-radio-group>
          <span class="frm-tips">若为第三方商家优惠券,请谨慎选择此项</span>
        </el-form-item>
        <el-form-item label="是否可叠加" prop="is_add">
          <el-radio-group v-model="form.is_add" >
            <el-radio   :label="0">不可叠加</el-radio>
            <el-radio   :label="1">可叠加</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用途类型" prop="use_type">
          <el-radio-group v-model="form.use_type" >
            <el-radio   :label="0">普通优惠券</el-radio>
            <el-radio   :label="1">红包券</el-radio>
            <el-radio   :label="2" disabled="true">运费券(暂时不开发)</el-radio>
            <p class="frm-tips">普通优惠券之间不可叠加<br>红包券最多和一张普通优惠券叠加<br>运费券仅参与运费优惠</p>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.use_scenes == 'SELF'" label="验证码">
          <el-radio-group v-model="self_rcode" :disabled="form.card_id != ''">
            <el-radio label="1">启用验证码</el-radio>
            <el-radio label="0">不启用验证码</el-radio>
          </el-radio-group>
          <br>
          <el-input v-if="self_rcode === '1'" v-model="form.self_consume_code" style="width: 220px;" placeholder="请输入验证码" maxlength=4 minlength=4></el-input>
        </el-form-item>
      </el-card>
      <el-card v-if="form.use_platform == 'mall' && form.card_type != 'gift'" header="商品" shadow="naver">
        <el-form-item label="适用商品">
          <el-radio-group v-model="form.use_all_items" @change="itemTypeChange">
            <el-radio label="true">全部商品适用</el-radio>
            <el-radio label="false">指定商品适用</el-radio>
            <el-radio label="other">指定商品不可用</el-radio>
          </el-radio-group>
        </el-form-item>
        <SkuSelector v-if="!zdItemHidden" @change="getItems" :data="relItems"></SkuSelector>
      </el-card>
      <el-card header="门店" shadow="naver" v-if="is_distributor == false && form.use_platform == 'store'">
        <el-form-item label="适用门店">
          <el-radio-group v-model="form.use_all_shops" @change="shopTypeChange">
            <el-radio label="true">全部门店适用</el-radio>
            <el-radio label="false">指定门店适用</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="!zdShopHidden">
          <el-button type="primary" @click="addStoreAction">选择店铺</el-button>
          <el-table v-if="distributor_info.length > 0" :data="distributor_info" style="line-height: normal">
            <el-table-column label="ID" prop="wxShopId" width="60"></el-table-column>
            <el-table-column label="名称" prop="storeName"></el-table-column>
            <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="50">
              <template slot-scope="scope">
                <i class="iconfont icon-trash-alt" @click="deleteRow(scope.$index)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-card header="店铺" shadow="naver" v-if="is_distributor == false && form.use_platform == 'mall'">
        <el-form-item label="适用店铺">
          <el-radio-group v-model="form.use_all_shops" @change="shopTypeChange">
            <el-radio label="true">全部适用</el-radio>
            <el-radio label="false">指定店铺适用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="以下店铺不可用">
            <el-checkbox-group v-model="form.distributor_id_noflag" @change="choseDistributorNo">
              <el-checkbox  label="true">怡康自营选中店铺不可用</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <div v-if="!zdShopHidden">
          <el-button type="primary" @click="addDistributorAction">选择店铺</el-button>
          <el-table v-if="distributor_info.length > 0" :data="distributor_info" style="line-height: normal">
            <el-table-column label="ID" prop="distributor_id" width="60"></el-table-column>
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="50">
              <template slot-scope="scope">
                <i class="iconfont icon-trash-alt" @click="deleteDistritutorRow(scope.$index, form.items)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      
      </el-card>
      <div class="content-center">
        <el-button @click="cancelSubmit">取消</el-button>
        <el-button type="primary" @click="submitForm('form')" :disabled="submitDisabled">提交</el-button>
      </div>
    </el-form>
    <StoreSelect :store-visible="storeVisible" :is-valid="true" :rel-shop-ids="relShopIds" :get-status="setStatus" @chooseStore="chooseStoreAction" @closeStoreDialog="closeStoreDialogAction"></StoreSelect>
    <DistributorSelect :store-visible="distributorVisible" :is-valid="true" :rel-shop-ids="relDistributorIds" :get-status="setDistributorStatus" @chooseStore="chooseDistributorAction" @closeStoreDialog="closeDistributorDialogAction"></DistributorSelect>
  </div>
</template>

<script>
  import store from '@/store'
  import StoreSelect from '@/components/storeselect'
  import DistributorSelect from '@/components/storeListSelect'
  import SkuSelector from '@/components/function/skuSelector'
  import { getCardDetail, getWechatColor, creatCard, updateCard,getCateList } from '@/api/cardticket'
  import { pushNewsImage, getAuthorizerInfo } from '@/api/wechat'
  import { getWxShopsList} from '@/api/shop'
  import { getItemsList } from '@/api/goods'
  export default {
    inject: ['refresh'],
    components: {
      StoreSelect,
      SkuSelector,
      DistributorSelect
    },
    data () {
      let tempDays = [{text: '当天', value: 0}]
      let tempRemainDays = []
      for (let i = 1; i <= 90; i++) {
        tempDays.push({text: i + '天', value: i})
        tempRemainDays.push({text: i + '天', value: i})
      }
      // 增加有效时间
      tempDays.push({text: 180 + '天', value: 180})
      tempRemainDays.push({text: 180 + '天', value: 180})
      tempDays.push({text: 365 + '天', value: 365})
      tempRemainDays.push({text: 365 + '天', value: 365})

      var useConditionChecked = (rule, value, callback) => {
        if (this.form.card_type === 'cash' && this.form.useCondition === 2) {
          var reg = /^\d*$/
          if (this.form.least_cost === '') {
            callback(new Error('请填写金额'))
          } else if (Number(this.form.least_cost) <= Number(this.form.reduce_cost)) {
            callback(new Error('填写金额必须大于减免金额'))
          } else {
            callback()
          }
        }
        if (this.form.card_type === 'discount' && this.form.useCondition === 2) {
          var reg = /^\d*$/
          if (this.form.most_cost === '') {
            callback(new Error('请填写金额'))
          } else if (Number(this.form.most_cost) <= Number(this.form.least_cost)) {
            callback(new Error('最高消费限额必须大于起用金额'))
          } else {
            callback()
          }
        }
        callback()
      }
      var quantityChecked = (rule, value, callback) => {
        let reg = /^\d*$/
        if (value === "") {
          callback(new Error('库存不能为空'))
        } else if (!reg.test(value)) {
          callback(new Error('库存必须为数字'))
        } else {
          callback()
        }
      }
      var dateChecked = (rule, value, callback) => {
        if (value == "DATE_TYPE_FIX_TIME_RANGE" && this.date_range == "") {
          callback(new Error('固定日期必填'))
        } else {
          callback()
        }
      }
      var titleChecked = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('卡券标题不能为空'))
        } else if (this.inputValue.title_length > this.inputValue.title_max) {
          callback(new Error('卡券标题长度不超过' + this.inputValue.title_max + '个汉字或' + (this.inputValue.title_max * 2) + '个英文字母'))
        } else {
          callback()
        }
      }
      var strTitleChecked = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('卡券标题不能为空'))
        } else if (this.inputValue.str_title_length > this.inputValue.str_title_max) {
          callback(new Error('卡券标题长度不超过' + this.inputValue.str_title_max + '个汉字或' + (this.inputValue.str_title_max * 2) + '个英文字母'))
        } else {
          callback()
        }
      }
      var descriptionChecked = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('卡券使用说明不能为空'))
        } else if (this.inputValue.description_length > this.inputValue.description_max) {
          callback(new Error('卡券使用说明长度' + this.inputValue.description_max + '个汉字或' + (this.inputValue.description_max * 2) + '个英文字母'))
        } else {
          callback()
        }
      }
      var discountChecked = (rule, value, callback) => {
        var reg = /(^[1-9]((\.)[0-9])?$)/
        if (value == '') {
          callback(new Error('折扣额度不能为空'))
        } else if(!reg.test(value)) {
          callback(new Error('折扣额度为1-9.9之间的数字，精确到小数点后1位'))
        } else {
          callback()
        }
      }
      var reduceCostChecked = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('减免金额不能为空'))
        } else if(parseFloat(value) > 0) {
            callback()
        } else {
            callback(new Error('减免金额必须大于0'))
        }
      }
      var useScenesChecked = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('至少选择一项使用场景'))
        }
        callback()
      }

      var merchantIsuseChecked = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('至少选择一项使用场景'))
        }
        callback()
      }
      var merchantIscostChecked = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('费用承担请谨慎选择'))
        }
        callback()
      }
      var useType = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('用途'))
        }
        callback()
      }
      var isAdd = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('是否可叠加'))
        }
        callback()
      }
      return {
        pickerOptions : {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        totalDays: tempDays,
        remainDays: tempRemainDays,
        datetimeStatus: true,
        articleItemIndex: -1,
        articleOprHidden: true,
        articleItem: {text: '', image_url: ''},
        addImgDefaultHidden: false,
        zdShopHidden: true,
        relDistributorNoIds: '',
        storeVisible: false,
        distributorVisible: false,
        itemVisible: false,
        setItemStatus: false,
        date_range:'',
        setStatus: false,
        setDistributorStatus: false,
        rel_shops_ids:[],
        distributor_info: [],
        relShopIds: '',
        relDistributorIds: '',
        submitDisabled: false,
        is_distributor: false,
        category:[],
        form: {
          color: '#000000',
          card_id: '',
          card_type: 'discount',
          promotion_type: 0,
          discount_again:1,
          title: '',
          str_title: '',
          least_cost: 0,
          reduce_cost: 0,
          discount: '',
          gift: '',
          description:'',
          quantity: 0,
          date_type: 'DATE_TYPE_FIX_TIME_RANGE',
          begin_time: 0,
          days: 30,
          end_time:'',
          time_limit_date:[],
          get_limit: 1,
          use_all_shops: 'true',
          rel_shops_ids:[],
          distributor_id: [],
          distributor_id_noflag: 'false',
          text_image_list: [],
          receive: true,
          can_qrcode_flag:false,
          use_scenes: 'QUICK',
          if_push_wechat:false,
          useCondition: 1,
          self_consume_code: 0,
          use_platform: 'store',
          merchant_isuse: 0,
          merchant_iscost:0,
          is_add:0,
          use_type:0,
          rel_item_ids: [],
          rel_item_bns: [],
          cate_id:'',
          use_all_items: 'true',
          most_cost:999999,
          min_buy_num:0,
          is_long:0,
        },
        relItems: [],
        kqhjCheckedItem:'',
        twxxCheckedItem:'',
        zdItemHidden: true,
        rules: {
          gift: [
            { required: true, message: '兑换商品名称不能为空', trigger: 'blur' }
          ],
          discount: [
            { type: 'number', required: true, validator: discountChecked, trigger: 'blur' }
          ],
          reduce_cost: [
            { type: 'number', required: true, validator: reduceCostChecked, trigger: 'blur' }
          ],
          title: [
            { required: true, validator: titleChecked, trigger: 'blur' }
          ],
          str_title: [
            { required: true, validator: strTitleChecked, trigger: 'blur' }
          ],
          date_type: [
            {required: true, validator: dateChecked, trigger: 'blur'}
          ],
          useCondition: [
            { required: true, validator: useConditionChecked, trigger: 'blur' }
          ],
          description: [
            { required: true, validator: descriptionChecked, trigger: 'blur' }
          ],
          quantity: [
            { required: true, validator: quantityChecked, trigger: 'blur' }
          ],
          use_scenes: [
            { required: true, validator: useScenesChecked, trigger: 'blur' }
          ],
          merchant_isuse: [
            { required: true, validator: merchantIsuseChecked, trigger: 'blur' }
          ],
          merchant_iscost: [
            { required: true, validator: merchantIscostChecked, trigger: 'blur' }
          ],
          is_add: [
            { required: true, validator: isAdd, trigger: 'blur' }
          ],
          use_type: [
            { required: true, validator: useType, trigger: 'blur' }
          ]
        },
        inputValue: {
          title_length: 0,
          title_max: 30,
          str_title_length: 0,
          str_title_max: 30,
          description_length: 0,
          description_max: 300,
          accept_category_length: 0,
          accept_category_max: 5,
          reject_category_length: 0,
          reject_category_max: 15,
          object_use_for_length: 0,
          object_use_for_max: 15,
          gift_length: 0,
          gift_max: 20
        },
        wechatColor:['#63b359','#2c9f67','#509fc9','#5885cf','#9062c0','#d09a45','#e4b138','#ee903c','#f08500','#a9d92d','#dd6549','#cc463d','#cf3e36','#5E6671','#026842'],
        self_rcode: '0',
      }
    },
    methods: {

      getItems(data) {
        let ids = []
        let bns = []
        data.forEach(item => {
          ids.push(item.itemId)
          bns.push(item.itemBn)
        })
        this.form.rel_item_ids = ids
        this.form.rel_item_bns = bns
      },
      usePlatformChange (val) {
        if (val=='mall') {
          this.form.use_scenes = 'ONLINE'
        } else {
          this.form.use_scenes = 'QUICK'
        }
      },
      checkColor (e) {
        this.form.color = e.target.dataset.color
      },
      changeDatetime (val) {
        if (val === 'DATE_TYPE_FIX_TIME_RANGE') {
          this.datetimeStatus = true
        } else {
          this.datetimeStatus = false
          this.date_range = ''
          this.begin_time = 0
        }
      },
      handleCateChange:function (val){
          this.form.cate_id = val
      },
      handlelongCateChange:function (val){
        this.form.is_long = val
      },
      handleTypeChange (val) {
        this.form.use_platform = this.is_distributor ? 'mall' : 'store'
        if (val === 'gift') {
          this.form.use_scenes = 'SELF'
        }
        if (val === 'cash' || val === 'discount') {
          this.form.useCondition = 2
          this.form.use_scenes = 'QUICK'
        }
      },
      shopTypeChange (val) {
        this.zdShopHidden = true
        if (val === "false") {
          this.zdShopHidden = false
        } else {
          this.form.distributor_id = []
        }
      },
      choseDistributorNo (val){
        if(val === 'true'){
          this.from.distributor_id_noflag = true
        }
      },
      itemTypeChange (val) {
        this.zdItemHidden = true
        if (val === "false" || val === "other") {
          this.zdItemHidden = false
        }
      },
      cancelSubmit () {
        this.$router.go(-1)
      },
      submitForm (formName) {
        const that = this
        if (this.form.date_type == "DATE_TYPE_FIX_TIME_RANGE" && this.date_range.length > 0) {
          this.form.begin_time = this.date_range[0]
          this.form.end_time = this.date_range[1]
        }
        if (this.form.use_scenes=="SELF" && this.self_rcode == '1') {
          if (!this.form.self_consume_code) {
            this.$message.error('选择自助核销并开启验证码后，验证码必填')
            return
          }
          if (this.form.self_consume_code && this.form.self_consume_code.length != 4) {
            this.$message.error('验证码必须为4个数字')
            return
          }
          let reg = /^\d*$/
          if (this.form.self_consume_code && !reg.test(this.form.self_consume_code)) {
            this.$message.error('验证码必须为纯数字')
            return
          }
        }
        if (this.form.use_all_shops === 'false' && !this.form.rel_shops_ids) {
          this.$message.error('请添加适用门店')
          return
        }
        if (this.form.use_scenes=="SELF" && this.self_rcode == '0') {
          this.form.self_consume_code = 0
        }

        let params = JSON.parse(JSON.stringify(this.form))

        if (params.date_type == "DATE_TYPE_FIX_TIME_RANGE") {
          params.begin_time = params.begin_time/1000
          params.end_time = params.end_time/1000
        } else {
          params.end_time = params.end_time/1000
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitDisabled = true
            if(this.form.card_id) {
              params.if_push_wechat = false
              updateCard(params).then(res => {
                if(res.data.data && res.data.data.status){
                  this.$message({
                    message: '更新成功',
                    type: 'success',
                    duration: 2 * 1000,
                    onClose () {
                      that.refresh()
                      that.$router.go(-1)
                    }
                  })
                } else {
                  this.$message.error('更新优惠券失败!')
                  this.submitDisabled = false
                  return false
                }
             }).catch(() => {
                this.submitDisabled = false
             })
            } else {
              creatCard(params).then(res => {
                if(res.data.data.status){
                  this.$message({
                    message: '添加成功',
                    type: 'success',
                    duration: 2 * 1000,
                    onClose () {
                      that.refresh()
                      that.$router.go(-1)
                    }
                  })
                } else {
                  this.$message.error('添加优惠券失败!')
                  this.submitDisabled = false
                  return false
                }
              }).catch(() => {
                this.submitDisabled = false
              })
            }
          } else {
            return false
          }
        })
      },
      addStoreAction () {
        this.storeVisible = true
        this.setStatus = true
        this.relShopIds = this.rel_shops_ids
      },
      addDistributorAction () {
        this.distributorVisible = true
        this.setDistributorStatus = true
        this.relDistributorIds = this.form.distributor_id
      },
      addDistributorAction2 () {
        this.distributorVisible = true
        this.setDistributorStatus = true
        this.relDistributorNoIds = this.form.distributorNo_id
      },
      chooseStoreAction (data) {
        this.storeVisible = false
        this.form.rel_shops_ids = []
        if (data === null || data.length <= 0) return
        this.rel_shops_ids = data
        for (var i = 0; i < data.length; i++) {
          if(this.form.rel_shops_ids.indexOf(data[i].wxShopId) < 0) {
            this.form.rel_shops_ids.push(Number(data[i].wxShopId))
          }
        }
      },
      chooseDistributorAction (data) {
        this.distributorVisible = false
        this.distributorVisible = false
        if (data === null || data.length <= 0) return
        this.distributor_info = data
        for (var i = 0; i < data.length; i++) {
          if(this.form.distributor_id.indexOf(Number(data[i].distributor_id)) < 0) {
            this.form.distributor_id.push(Number(data[i].distributor_id))
          }
        }
      },
      closeStoreDialogAction () {
        this.storeVisible = false
      },
      closeDistributorDialogAction () {
        this.distributorVisible = false
      },
      deleteRow (index) {
        this.rel_shops_ids.splice(index, 1)
        this.form.rel_shops_ids = []
        let shopDatas = this.rel_shops_ids
        for (var i = 0; i < shopDatas.length; i++) {
          if(this.form.rel_shops_ids.indexOf(Number(shopDatas[i].wxShopId)) < 0) {
            this.form.rel_shops_ids.push(Number(shopDatas[i].wxShopId))
          }
        }
      },
      deleteDistritutorRow (index) {
        this.distributor_info.splice(index, 1)
        let shopDatas = this.distributor_info
        this.form.distributor_id = []; // 重新初始化 distributor_id 为空数组（修复删除后店铺ID依然存在的BUG）
        for (var i = 0; i < shopDatas.length; i++) {
          if(this.form.distributor_id.indexOf(Number(shopDatas[i].distributor_id)) < 0) {
            this.form.distributor_id.push(Number(shopDatas[i].distributor_id))
          }
        }
      },
      giftChange (value) {
        this.inputValue.gift_length = this.getValueLength(value)
      },
      titleChange (value) {
        this.inputValue.title_length = this.getValueLength(value)
      },
      strTitleChange (value) {
        this.inputValue.str_title_length = this.getValueLength(value)
      },
      descriptionChange (value) {
        this.inputValue.description_length = this.getValueLength(value)
      },
      getValueLength (value) {
        let realLength = 0, charCode = -1, count = 0
        for (var i = 0; i < value.length; i++) {
          charCode = value.charCodeAt(i)
          if (charCode >= 0 && charCode <= 128) {
            count ++
          } else {
            realLength ++
          }
        }
        if (count > 0) {
          realLength = realLength + parseInt(count / 2)
          if (count % 2 > 0) {
            realLength += 1
          }
        }
        return realLength
      },
      conditionChange (val) {
        if (val == 1 ) {
          this.form.least_cost = 0
        }
        if(val == 2 && this.form.card_type === 'discount'){
          this.form.most_cost = 999999
        }
      }
    },
    mounted () {
      getCateList({page:1,pageSize:-1}).then(res=>{
          if(res.data){
              this.category = res.data.data.list
              this.form.cate_id = this.category[0].cate_id
          }
      })

      if (store.getters.login_type === 'distributor') {
        this.is_distributor = true
        this.form.use_platform = 'mall'
          console.log(this.form.use_platform)
      }
      if (this.$route.query.chooseCardtype) {
        this.form.card_type = this.$route.query.chooseCardtype
      }
      if (this.form.card_type == 'cash') {
        this.form.useCondition = 2
      }
      if (this.$route.query.cardId) {
        this.form.card_id = this.$route.query.cardId
      }
      let params = {
        card_id: this.form.card_id
      }
      if (!this.form.card_id && this.form.card_type == "gift") {
        this.form.use_scenes = "SELF"
      }
      if (this.form.card_id) {
        getCardDetail(params).then(res => {
          Object.assign(this.form, res.data.data)
          if(res.data.data.can_qrcode_flag=="1"){
              this.form.can_qrcode_flag = true;
          }else{
              this.form.can_qrcode_flag = false;
          }
          this.form.promotion_type = parseInt(res.data.data.promotion_type)
          if(res.data.data.merchant_isuse=="1"){
              this.form.merchant_isuse = 1;
          }else if(res.data.data.merchant_isuse=="2"){
              this.form.merchant_isuse = 2;
          }else{
              this.form.merchant_isuse = 0;
          }
          if(res.data.data.merchant_iscost=="1"){
              this.form.merchant_iscost = 1;
          }else{
              this.form.merchant_iscost = 0;
          }
          if(res.data.data.use_type=="1"){
              this.form.use_type = 1;
          }else if(res.data.data.use_type=="2"){
              this.form.use_type = 2;
          }else{
              this.form.use_type = 0;
          }
          if(res.data.data.is_add=="1"){
              this.form.is_add = 1;
          }else{
              this.form.is_add = 0;
          }
          if (this.form.date_type == 'DATE_TYPE_FIX_TIME_RANGE') {
            this.date_range = [this.form.begin_time * 1000, this.form.end_time * 1000]
            this.form.days = 30
          } else {
            if (this.form.end_time <= 0) {
              this.form.end_time = ""
            } else {
              this.form.end_time = this.form.end_time * 1000
            }
          }

          if (this.form.use_all_items === "false"||this.form.use_all_items === "other") {
            this.zdItemHidden = false
          }
          if (this.form.use_all_shops === "false") {
            this.zdShopHidden = false
          }

          if (this.form.card_type == "gift" && (this.form.use_scenes != "SWEEP" && this.form.use_scenes != "SELF")) {
            this.form.use_scenes = "SELF"
          }

          if (parseInt(this.form.least_cost)) {
            this.form.useCondition = 2
          } else {
            this.form.useCondition = 1
          }

          if (!this.form.self_consume_code || this.form.self_consume_code == 0) {
            this.self_rcode = '0'
          } else {
            this.self_rcode = '1'
          }

          if (this.form.rel_shops_ids.length > 0) {
            this.shopTypeChange("false")
            let shopParams = {wx_shop_id: this.form.rel_shops_ids, page: 1, pageSize: 500, isValid: true}
            getWxShopsList(shopParams).then(res => {
              this.rel_shops_ids = res.data.data.list
            })
          }
          let response = res.data.data
          this.distributor_info = response.distributor_info
          this.form.distributor_id = []
          for (var i in this.distributor_info) {
            if(this.form.distributor_id.indexOf(Number(this.distributor_info[i].distributor_id)) < 0) {
              this.form.distributor_id.push(Number(this.distributor_info[i].distributor_id))
            }
          }
          this.$nextTick(() => {
            this.relItems = response.itemTreeLists
            console.log(this.relItems )
          })
          this.titleChange(this.form.title)
          this.descriptionChange(this.form.description)
          console.log(this.form)
        })
      }
    }
  }

</script>
<style scoped lang="scss">
  .card-content {
    &-head {
      text-align: center;
      color: #fff;
      padding: 20px 15px;
      font-size: 14px;
      .price {
        font-size: 32px;
      }
      .validity-date {
        color: #efefef;
        font-size: 12px;
      }
    }
    &-body {
      padding: 20px 15px;
      min-height: 400px;
      background: #fff;
      .barcode-img {
        width: 160px;
        height: 80px;
        margin: 0 auto 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .code-img {
        width: 120px;
        height: 118px;
        margin: 0 auto 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .txt-title {
        color: #333;
        font-weight: bold;
      }
      .txt-content {
        padding-left: 15px;
        span {
          margin: 0 5px;
        }
      }
    }
  }
  .bd {
    border-bottom: 1px dashed #ddd;
  }
  .mb {
    margin-bottom: 10px;
  }
  .card-edit-detail {
    background: #fff;
    input { width: 30%; }
  }
  .affix {
    position: fixed;
    width: 320px;
    overflow: hidden;
  }
  .section-footer {
    padding: 15px 10px;
    text-align: center;
    .with-border { border-top: 1px solid #f8f8f8; }
  }
  .card_article_box .card_article_img {
    background-color: #fff;
  }
  .media_edit {
    display: block;
    position: relative;
    z-index: 2;
    float: none;
    min-width: 800px;
    margin-left: 340px;
  }
  .tips { margin-left: 2px; }
  .el-select {
    width: 110px;
  }
</style>
<style type="text/css" lang="scss">
  .color-group {
    li {
      width: 30px;
      height: 30px;
      float: left;
      cursor: pointer;
      &:hover {
        border: 2px solid #fff;
      }
      &.active {
        border: 2px solid #fff;
      }
    }
  }
  .el-radio-group {
    .el-radio__input.is-checked+.el-radio__label, .el-radio__input.is-checked .el-radio__inner {
      color: #606272;
    }
  }
  .el-checkbox-group {
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #606272;
    }
  }
</style>



// WEBPACK FOOTER //
// edit.vue?46dab17a